/* @flow */
import QueryString from 'qs';

export const NEW_MESSAGE_PATHS = [
  '/messages/new',
  '/classes/[^/]*/messages/new',
  '/chat/new',
  '/inbox/new',
];

function extractQueryString(url: string): string {
  const match = url.match(/[^?]*\?(.*)/);
  return match ? match[1] : '';
}

/* Some deeplinks conflict with one-off apps, so we fix certain urls
 *   before sending them to the router. If they don't conflict, we just
 *   pass them through.
 */
export default (url: string): string => {
  const matchedNewMessagePath = NEW_MESSAGE_PATHS.find(p => url.match(p));
  if (matchedNewMessagePath) {
    // Rename attachment
    const { attachment, ...queryDict } = QueryString.parse(extractQueryString(url));
    queryDict.attachmentId = attachment;

    return '/classes?' + QueryString.stringify({ queryParams: queryDict, action: 'new-message' });
  } else {
    return url;
  }
};



// WEBPACK FOOTER //
// ./src/lib/resolveDeeplinkRedirects.js